import { Component, OnInit } from '@angular/core';
import { OkAloneService } from '../../../ok-alone.service';

@Component({
  selector: 'app-worker-reports',
  templateUrl: './worker-reports.component.html',
  styleUrls: ['./worker-reports.component.scss']
})
export class WorkerReportsComponent implements OnInit {

  constructor(public okService: OkAloneService) { }

  ngOnInit(): void {
  }

}
